import React from 'react';
import { faFileExport } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './ExportButton.module.css';
import { CommonButton } from '_components';


export class ExportButton extends React.Component {
    render() {
        let cls;
        cls = styles.button;

        if (this.props.className ) {
            cls += ' ' + this.props.className;
        }

        return (
            <CommonButton title={this.props.title} onClick={this.props.onClick} size={this.props.size} className={cls} >
                <FontAwesomeIcon icon={faFileExport} transform="shrink-6" color="white" />
            </CommonButton>
        );
    }
}

